import type { NavRoute } from '~/layouts/Admin/RoutePermissions';
import type { StaffSideBarRoute } from '~/staff-sidebar-routes';

export type SidebarRoute = NavRoute | StaffSideBarRoute;

/**
 * checks if any collapse routes should be open on initial render
 * (e.g. when refreshing while on a nested route)
 */
export function getCollapseInitialState(routesForInitialState: SidebarRoute[]): boolean {
  for (let i = 0; i < routesForInitialState.length; i += 1) {
    const route = routesForInitialState[i];
    if (
      route.collapse &&
      Array.isArray(route.views) &&
      getCollapseInitialState(route.views as SidebarRoute[])
    ) {
      return true;
    }
    if (window.location.href.indexOf(route.path) !== -1) {
      return true;
    }
  }
  return false;
}

/**
 * builds initial collapse state map for all collapsible routes
 * recursively processes nested routes to create state keys
 */
export function getCollapseStates(routes: SidebarRoute[]): Record<string, boolean> {
  const collapseStateMap: Record<string, boolean> = {};
  routes.forEach((prop) => {
    if (
      prop.collapse &&
      prop.state &&
      typeof prop.state === 'string' &&
      Array.isArray(prop.views)
    ) {
      const views = prop.views as SidebarRoute[];
      collapseStateMap[prop.state] = getCollapseInitialState(views);
      const nestedStates = getCollapseStates(views);
      Object.keys(nestedStates).forEach((key) => {
        collapseStateMap[key] = nestedStates[key];
      });
    }
  });
  return collapseStateMap;
}
